// useConfirmation.ts
import { useState, useCallback } from 'react';

interface UseConfirmation {
  open: boolean;
  params: { title: string; message: string } | null;
  show: (title: string, message: string) => void;
  confirm: () => void;
  cancel: () => void;
}

export function useConfirmation({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel?: () => void;
}): UseConfirmation {
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState<{ title: string; message: string } | null>(null);

  const show = useCallback((title: string, message: string) => {
    setParams({ title, message });
    setOpen(true);
  }, []);

  const confirm = useCallback(() => {
    setOpen(false);
    onConfirm();
  }, [onConfirm]);

  const cancel = useCallback(() => {
    setOpen(false);
    onCancel?.();
  }, [onCancel]);

  return { open, params, show, confirm, cancel };
}
